import { Directive, ElementRef, AfterViewInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { fromEvent, Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';

@Directive({
  selector: '[appMeasure]'
})
export class MeasureDirective implements AfterViewInit, OnDestroy {
  @Output() width = new EventEmitter<number>();
  private onDestroy$ = new Subject<void>();

  constructor(private elementRef: ElementRef<HTMLElement>) {}

  ngAfterViewInit(): void {
    this.emitWidth();

    fromEvent(window, 'resize')
      .pipe(debounceTime(10), takeUntil(this.onDestroy$))
      .subscribe(() => this.emitWidth());
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
  }

  private emitWidth() {
    this.width.emit(this.elementRef.nativeElement.getBoundingClientRect().width);
  }
}
